import { render } from "./PageBanner.vue?vue&type=template&id=124e03b6&scoped=true"
import script from "./PageBanner.vue?vue&type=script&lang=js"
export * from "./PageBanner.vue?vue&type=script&lang=js"

import "./PageBanner.vue?vue&type=style&index=0&id=124e03b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124e03b6"]])

export default __exports__